import { apiClient } from '../Auth/apiClient';
import { IRuleDetailsDto, IRuleUpsertDto, IRuleUpdateDto } from '../Interfaces/IRuleDtos';
import ISearchBaseDto from '../Interfaces/ISearchBaseDto';
import IResponseBaseTDto from '../Interfaces/IResponseBaseTDto';
import IPageResultDto from '../Interfaces/IPageResultDto';
import IResponseBaseDto from '../Interfaces/IResponseBaseDto';

const RuleServiceAPI = {
	GetOne: async (id: number): Promise<IRuleDetailsDto> => {
		const response = await apiClient.post('rule', { id });
		return response.data;
	},
	GetPage: async (data: ISearchBaseDto): Promise<IResponseBaseTDto<IPageResultDto<any>>> => {
		const response = await apiClient.post('rules', data);
		return response.data;
	},
	Delete: async (id: number): Promise<IResponseBaseDto> => {
		const response = await apiClient.post('rule/delete', { id });
		return response.data;
	},
	Add: async (data: IRuleUpsertDto): Promise<IResponseBaseDto> => {
		const response = await apiClient.post('rule/create', data);
		return response.data;
	},
	Update: async (data: IRuleUpdateDto): Promise<IResponseBaseDto> => {
		const response = await apiClient.put('rule/update', data);
		return response.data;
	},
};

export default RuleServiceAPI;
